import React from "react";

const NextStepsIcon = () => {
  return (
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.274587 11.5245C0.098772 11.7003 0 11.9387 0 12.1874V15.0624C0 15.6147 0.447715 16.0624 1 16.0624H17.125C17.6773 16.0624 18.125 15.6147 18.125 15.0624V0.937378C18.125 0.688737 18.0262 0.450281 17.8504 0.274465C17.6746 0.0986498 17.4361 -0.00012207 17.1875 -0.00012207H14.0625C13.8139 -0.00012207 13.5754 0.0986498 13.3996 0.274465C13.2238 0.450281 13.125 0.688737 13.125 0.937378V2.74988C13.125 3.30216 12.6773 3.74988 12.125 3.74988H9.6875C9.43886 3.74988 9.2004 3.84865 9.02459 4.02446C8.84877 4.20028 8.75 4.43874 8.75 4.68738V6.49988C8.75 7.05216 8.30228 7.49988 7.75 7.49988H5.3125C5.06386 7.49988 4.8254 7.59865 4.64959 7.77447C4.47377 7.95028 4.375 8.18874 4.375 8.43738V10.2499C4.375 10.8022 3.92728 11.2499 3.375 11.2499H0.9375C0.68886 11.2499 0.450403 11.3487 0.274587 11.5245Z"
        fill="#30323A"
      />
    </svg>
  );
};

export default NextStepsIcon;
